import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { API_CONSTANTS } from "../../constants/api.constants";
import { IF_LoginReq } from "../../interfaces/login.interface";

@Injectable()
export class LoginApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public doLogin(payload: IF_LoginReq) {
    payload.deviceId =
      "dapxDzCySkg:APA91bFte8-oCXMYKJp016cUG7DcGprawTKhzxOSVXA7B55TzYTuYPTPZ6QLAT3Ei8wu0WKc0eIbBlQJosDq50s_fn66Bu0RRla2sPKNEBorqRJfTwTAlC_ssuCSb6Fur7PgqnMHeseo";
    return this.httpClient.post(API_CONSTANTS.LOGIN, payload);
  }

  public getPermission(id): any {
    return this.httpClient.get(`${API_CONSTANTS.PERMISSION}/${id}`);
  }

  public getActiveLang(): any {
    return this.httpClient.get(API_CONSTANTS.ACTIVE_LANG);
  }

  public getSystemConfig(): any {
    return this.httpClient.get(API_CONSTANTS.SYSTEM_CONFIG);
  }
}
